<script setup lang="ts" generic="Value, Content">
import ChatDiagnosisTemplateInputItemLayout from './ChatDiagnosisTemplateInputItemLayout.vue';
import RadioBlock, {
  type RadioBlockOption,
} from 'theme/components/molecules/RadioBlock.vue';

const props = withDefaults(
  defineProps<{
    modelValue: Value;
    title: string;
    name: string;
    notes?: string[];
    options: RadioBlockOption<Value, Content>[];
    inactive: boolean;
    singleColumn?: boolean;
  }>(),
  {
    notes: () => [],
    singleColumn: false,
  }
);

const emit = defineEmits<{
  'update:modelValue': [value: Value];
}>();

const wrappedModelValue = computed<Value>({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <ChatDiagnosisTemplateInputItemLayout
    :title="title"
    :notes="notes"
    :inactive="inactive"
    tag="div"
  >
    <template #input>
      <div
        :class="[
          $style.selections,
          { [$style['selections--single-column']]: singleColumn },
        ]"
      >
        <RadioBlock
          v-for="(option, i) in options"
          :key="i"
          v-model="wrappedModelValue"
          :option="option"
          :name="name"
          :class="$style.selections__item"
        >
          <template #default="{ content }">
            <slot :content="content">{{ content }}</slot>
          </template>
        </RadioBlock>
      </div>
    </template>
  </ChatDiagnosisTemplateInputItemLayout>
</template>

<style lang="scss" module>
.selections {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 16px;

  &--single-column {
    grid-template-columns: 1fr;
  }
}
</style>
